import styled, { keyframes } from "styled-components";
import { colors } from "constants/colors";

export const LTR_DURATION_S = 2;
export const CHAR_DURATION_S = 0.35;
export const CHAR_STAGGER_S = 0.08;
export const WORD_DURATION_S = 0.2;
export const WORD_STAGGER_S = 0.12;

const BLUR_PX = 8;
const LTR_OFFSET_PX = 20;

// 전체 컨텐츠 왼쪽 → 오른쪽 등장
const revealLtr = keyframes`
  from {
    transform: translateX(-${LTR_OFFSET_PX}px);
  }
  to {
    transform: translateX(0);
  }
`;

// 글자 짝수/홀수 블러·오파시티 등장
const blurRevealIn = keyframes`
  from {
    opacity: 0;
    filter: blur(${BLUR_PX}px);
  }
  to {
    opacity: 1;
    filter: blur(0);
  }
`;

// 본문 단어 아래 → 위 등장
const riseRevealIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledIntroTitleBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

// 타이틀 전체 LTR 등장 래퍼
export const StyledLtrReveal = styled.div<{ $delayS: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(-${LTR_OFFSET_PX}px);
  animation: ${revealLtr} ${LTR_DURATION_S}s ease-out both;
  animation-delay: ${({ $delayS }) => $delayS}s;
`;

export const StyledDateTitle = styled.h3`
  margin: 0;
  color: ${colors.white};
  font-size: 30px;
  font-weight: 400;
  line-height: 45px;
  letter-spacing: -1.5px;
  text-align: center;
`;

export const StyledMainTitle = styled.h2`
  margin: 2px 0 16px;
  color: ${colors.white};
  font-size: 38px;
  line-height: 46px;
  letter-spacing: -1.5px;
  text-align: center;
`;

export const StyledSubTitleBox = styled.div`
  opacity: 0.6;
  margin-bottom: 20px;
  text-align: center;
`;

// StyledText는 \n 줄바꿈이 안 됨
export const StyledSubTitleLine = styled.p`
  margin: 0;
  color: ${colors.white};
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.7px;
  text-align: center;
`;

export const StyledChar = styled.span<{ $delayS: number }>`
  display: inline-block;
  opacity: 0;
  filter: blur(${BLUR_PX}px);
  animation: ${blurRevealIn} ${CHAR_DURATION_S}s ease-out both;
  animation-delay: ${({ $delayS }) => $delayS}s;
`;

export const StyledWord = styled.span<{ $delayS: number }>`
  display: inline-block;
  opacity: 0;
  white-space: pre;
  animation: ${riseRevealIn} ${WORD_DURATION_S}s ease-out both;
  animation-delay: ${({ $delayS }) => $delayS}s;
`;
